import { render, staticRenderFns } from "./TerritoryList.vue?vue&type=template&id=9c286df4&scoped=true&"
import script from "./TerritoryList.vue?vue&type=script&lang=js&"
export * from "./TerritoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c286df4",
  null
  
)

export default component.exports